import { environment } from '../../environments/environment'

export const DATE_FORMAT = 'MM/dd/yyyy h:mm a ZZZZ'

/** Base for every v1 BFF call, matching `ApiService`'s `${baseURL}/v1/agent/...` composition. */
export const API_V1_BASE_URL = `${environment.axiosConfig.baseURL}/v1`
